/** The wizard walks customer → contract → site → container groups → schedule; each step creates what the next points at. */
export const ONBOARDING_STEPS = [
  "customer",
  "contract",
  "location",
  "containerGroups",
  "schedule",
] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export type OnboardingProgress = {
  organizationId?: bigint;
  contractId?: bigint;
  locationId?: bigint;
};

export function isStepUnlocked(step: OnboardingStep, progress: OnboardingProgress): boolean {
  switch (step) {
    case "customer":
      return true;
    case "contract":
      return progress.organizationId != null;
    case "location":
      return progress.contractId != null;
    case "containerGroups":
    case "schedule":
      // Locked until step 3 creates or picks a site, for an existing customer too.
      return progress.locationId != null;
  }
}

export function nextStep(step: OnboardingStep): OnboardingStep | undefined {
  const index = ONBOARDING_STEPS.indexOf(step);
  return ONBOARDING_STEPS[index + 1];
}
